import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { withStyles } from '@material-ui/core/styles';
import TerminalsContainer from '../../containers/logistics/Terminals';
import { getSharedStyles } from '../../themes';
import FMPTerminalMultiSelect from '../../components/pureForm/FMPTerminalMultiSelect';
import { ingestedTerminalIds } from './constants';

export const isLocalhost = Boolean(window.location.hostname === 'localhost');

const styles = (theme) => {
	return {
		...getSharedStyles(theme),
	};
};

class RailcarTerminalMultiSelect extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			isSearching: false,
		};
	}

	componentDidMount() {
		//- Only used for updates
		const { terminals, searchTerminals } = this.props;

		if (_.isEmpty(terminals)) {
			searchTerminals();
		}
	}

	render() {
		const { terminals } = this.props;

		const filteredTerminals = terminals.filter((t) =>
			_.includes(ingestedTerminalIds, t.terminalId)
		);

		if (_.isEmpty(terminals)) {
			return <div>Loading...</div>;
		}

		return <FMPTerminalMultiSelect {...this.props} terminals={filteredTerminals} />;
	}
}

RailcarTerminalMultiSelect.propTypes = {
	terminals: PropTypes.array,
	searchTerminals: PropTypes.func.isRequired,

	label: PropTypes.string,
	value: PropTypes.array,
	path: PropTypes.string.isRequired,
	isRequired: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles), TerminalsContainer])(RailcarTerminalMultiSelect);
